import UXCoreLayout from './UXCoreLayout';

export default UXCoreLayout;
